function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { transformUtil } from 'js-utils/transformation';
import { Schema, arrayOf } from 'normalizr';
import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
export var formatTransformedEventsWithCollection = function formatTransformedEventsWithCollection(events, eventIds) {
  var formattedEvents = {};
  forEach(eventIds, function (eventId) {
    var _objectSpread2;

    var _events$eventId = events[eventId],
        _events$eventId$myCol = _events$eventId.myCollections;
    _events$eventId$myCol = _events$eventId$myCol === void 0 ? {} : _events$eventId$myCol;

    var _events$eventId$myCol2 = _events$eventId$myCol.collections,
        collections = _events$eventId$myCol2 === void 0 ? [] : _events$eventId$myCol2,
        eventData = _objectWithoutPropertiesLoose(_events$eventId, ["myCollections"]);

    var collectionIds = collections.map(function (_ref) {
      var id = _ref.id;
      return id;
    });
    formattedEvents = _objectSpread({}, formattedEvents, (_objectSpread2 = {}, _objectSpread2[eventId] = _objectSpread({
      eventCollections: collectionIds
    }, eventData), _objectSpread2));
  });
  return formattedEvents;
};
/*
 * @param eventResponse -- {events: [{event_object}], pagination: {paginationObject}}
 *
 * returns
 * {
 *   events: {
 *     eventId: {eventObject},
 *     eventId: {}...
 *   },
 *   ids: [string],
 *   continuation: number,
 *   pageCount: number,
 *   totalItems: number,
 * }
 */

export var transformForRedux = function transformForRedux(eventResponse) {
  if (eventResponse === void 0) {
    eventResponse = {};
  }

  var _eventResponse = eventResponse,
      _eventResponse$events = _eventResponse.events,
      events = _eventResponse$events === void 0 ? {} : _eventResponse$events,
      _eventResponse$pagina = _eventResponse.pagination,
      pagination = _eventResponse$pagina === void 0 ? {} : _eventResponse$pagina;
  var content = new Schema('events');
  /* Parse the events into by ID entities */

  var _transformUtil = transformUtil({
    response: {
      events: events
    },
    schema: {
      events: arrayOf(content)
    }
  }),
      _transformUtil$entiti = _transformUtil.entities;

  _transformUtil$entiti = _transformUtil$entiti === void 0 ? {} : _transformUtil$entiti;
  var normalizedEvents = _transformUtil$entiti.events,
      normalizedEventIds = _transformUtil.result.events;
  var normalizedEventsWithFormattedCollection = formatTransformedEventsWithCollection(normalizedEvents, normalizedEventIds);
  /* Build pagination object */

  var hasMoreItems = pagination['has_more_items'],
      totalItems = pagination['object_count'],
      continuation = pagination.continuation;
  return {
    events: normalizedEventsWithFormattedCollection,
    ids: isEmpty(normalizedEventIds) ? [] : normalizedEventIds,
    hasMoreItems: hasMoreItems,
    continuation: continuation,
    totalItems: totalItems
  };
};